<template>
  <div v-if="items.length" class="shipping-types-chain mb-90">
    <public-service-links-grid title="Другие виды грузов" :items="items" text-only />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useShippingTypesStore } from '~/stores/shipping-types'
import PublicServiceLinksGrid from '~/components/public/public-service-links-grid.vue'

const { getShippingTypesChainItems } = useShippingTypesStore()

const props = defineProps({
  current: {
    type: String,
    default: 'oversized'
  }
})

const items = ref([] as any)

onMounted(async () => {
  items.value = await getShippingTypesChainItems(props.current)
})
</script>
